import React, { useState, } from 'react';
import PropTypes from 'prop-types';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import AutopayDetail from './AutopayDetail';

const AutopayDetailModal = ({ selectedAccount, }) => {
  const [ show, setShow, ] = useState(false);

  return (
    <>
      <Button variant='primary' onClick={() => setShow(true)}>
        Details
      </Button>
      <Modal show={show} onHide={() => setShow(false)} size="xl">
        <Modal.Header closeButton>
          <Modal.Title>Autopay Account Detail</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <AutopayDetail selectedAccount={selectedAccount} />
        </Modal.Body>
        <Modal.Footer />
      </Modal>
    </>
  );
};

AutopayDetailModal.propTypes = {
  selectedAccount: PropTypes.instanceOf(Object).isRequired,
};

export default AutopayDetailModal;
